var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popup',{attrs:{"button-style":"text","button-class":_vm.buttonStyle,"heading":"Tower Provider Sites","button-text":_vm.name,"button-size":"mini","show-save":false,"button-icon":"fa fa-grid"}},[_c('popup-sites-report',{attrs:{"name":_vm.name,"site-group":_vm.siteGroup,"supplier-id":_vm.supplierId,"status":_vm.status}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }